import * as angular from "angular";
import {IController} from "angular";

export class PodStateSelectComponent implements IController {
  pod: any;
  onChange: Function;

  constructor() {
  }

  changeStateTo(selectedValue) {
    this.pod.value = selectedValue;
    this.onChange({pod: this.pod});
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('podStateSelect', {
    bindings: {
      pod: '<',
      onChange: '&'
    },
    template: require('./pod-state-select.html').default,
    controller: PodStateSelectComponent
  });
